import {
    Box,
    Stack,
    Text,
} from "@mbank-design/design-system/components";
import React, {useContext, useState} from "react";
import {InvitationDatesContext} from "./InvitationDatesContext";
import SpeakerInvitationDaysHeader from "./SpeakerInvitationDaysHeader";
import {BoxBackgroundColor} from "@mbank-design/design-system/enums";
import Day from "./Day";
import _ from "lodash";

export default function SpeakerInvitationDays() {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
    const {dates} = useContext(InvitationDatesContext);
    const sortedDates = _.orderBy(dates, (d) => d.date);
    
    const onSelectedDayChanged = (date: Date | undefined) => {
        setSelectedDate(date);      
    };
    
    return(dates && dates.length > 0 ?
      (<Stack>
          <SpeakerInvitationDaysHeader />
          <Box background={BoxBackgroundColor.MONO_200}>
              {sortedDates.map(d => (
                  <Box key={d.date.toString()} padding={8}>
                      <Day day={d} selectedDate={selectedDate} onSelectedDayChanged={onSelectedDayChanged} />
                  </Box>
              ))}
          </Box>
      </Stack>) : (<Text>Nothing to display!</Text>)
    )
}